import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import negro from '../img/n3.jpg'
import nordico from '../img/c2.jpeg'
import flor from '../img/flor1.jpeg'
import ilus from '../img/ilus1.jpeg'
import styled from '@emotion/styled';
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';
import  {Click} from './StyleComponents';


const Container = styled.div`
    display: block;
    margin-bottom: 1.5rem;
    @media (min-width: 768px) {
 
    }
`;

const Img = styled.img`
    width: 300px;
    height: 300px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    :hover {
        transform: scale(1.02);
        filter: grayscale(1);
		}
 @media (min-width: 768px) {
        width: 500px;
        height: 500px;
        }
`;
const Img2 = styled.img`
    width: 300px;
    height: 400px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    :hover {
        transform: scale(1.02);
        filter: grayscale(1);
		}
   @media (min-width: 768px) {
    width: 400px;
    height: 530px;
    }
`;

const Text = styled.p`
    font-size: 1.5rem;
    display: flex;
    justify-content: center;
    padding: 1rem;
`;

const Main = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);
    return (
        <>
            <Header />
            <Click>Dale click a las imagenes para ver los precios y más información</Click>
 
            <Container>
                <div data-aos="fade-down">
                        <Text>Pressed Flowers</Text>
                        <Link to={'/flowers'}>
                        <Img2 src={`${flor}`} />
                        </Link>
                </div>

                <div data-aos="fade-down">
                    <Text>Cuadro Flotante</Text>
                    <Link to={'/flotante'}>
                    <Img src={`${negro}`} />
                    </Link>
                </div>
                <div data-aos="fade-down">
                    <Text>Cuadro Nordico</Text>
                    <Link to={'/nordico'}>
                    <Img2 src={`${nordico}`} />
                    </Link>
                </div>
                
            </Container>
            <Container>
                    <div data-aos="fade-down">
                        <Text> Ilustración Digital</Text>
                        <Link to={'/ilust'}>
                        <Img2 src={`${ilus}`} />
                        </Link>
                    </div>
            </Container>
            <Footer />
        </>
    );
}

export default Main;